export const createLogoutHandler =
  (logout) =>
  (...args) => {
    logout(...args);
  };
